import StyledModal, { BaseModalBackground } from "styled-react-modal";
import styled from "styled-components";
import { StickyHeader } from "../styled-components/Layout";

export const Modal = StyledModal.styled`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.theme.modal.background};
  font-size: 12px;
  max-width: 75%;
  max-height: 75%;
  font-family: 'Verdana';
  color: ${props => props.theme.text.primary};
  box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
`;

export const ModalOverlay = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 30;
  background-color: ${props => props.theme.overlay};
`;

export const ModalHeader = styled(StickyHeader)`
  display: flex;
  color: ${props => props.theme.modal.headerText};
  background-color: ${props => props.theme.modal.header};
  padding-left: 0.2rem;
  justify-content: space-between;

  & > span {
    padding: 0.1rem 0.2rem;
  }
`;



// WEBPACK FOOTER //
// ./app/styled-components/Modal.js